/**
 * @summary Contains main menu drawer menu preact component.
 */

import { h, Component } from 'preact';
import Menu from './Menu';

/**
 * @summary Main menu drawer menu preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
export default class MainMenuDrawer extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			open: false,
			focus: false
		};

		this.focusTargets = {};
		this.docBody = document.body;

		this.open = this.open.bind( this );
		this.close = this.close.bind( this );
	}

	/**
	 * @summary Opens the drawer from a click event.
	 *
	 * @listens document:click
	 *
	 * @param {Event} event The event from which the open command comes from.
	 */
	open( event ) {
		this.setState({
			open: true,

			// Focus to drawer title if keyboard synthetic click (e.g. enter key)
			focus: event.x + event.y === 0 && 'drawerTitle'
		});
	}

	/**
	 * @summary Closes the drawer from a click event.
	 *
	 * @listens document:click
	 *
	 * @param {Event} event The event from which the close command comes from.
	 */
	close( event ) {
		this.setState({
			open: false,

			// Focus to open button if keyboard synthetic click (e.g. enter key)
			focus: event.x + event.y === 0 && 'openButton'
		});
	}

	componentDidMount() {

		// Add Esc to close the drawer
		document.addEventListener( 'keydown', this.close );
	}

	componentWillUnmount() {

		// Remove Esc event listener
		document.removeEventListener( 'keydown', this.close );
	}

	componentDidUpdate() {
		const focusTarget = this.state.focus;
		if ( focusTarget && focusTarget in this.focusTargets ) {
			this.focusTargets[focusTarget].focus();
		}
	}

	/**
	 * @summary Modifies scroll-ability of the document body.
	 *
	 * @param {bool} open Whether this drawer component state is set to open.
	 */
	modifyBodyScroll( open ) {
		const beforeWidth = this.docBody.offsetWidth;

		// Remove scrolling from body
		this.docBody.style.overflow = open ? 'hidden' : '';

		// Compensate for possible scrollbar layout jump
		const widthDiff = this.docBody.offsetWidth - beforeWidth;
		this.docBody.style.paddingRight = open ? `${widthDiff}px` : '';
	}

	render({ menuTree, classes, localizedStrings, hide }, { open }) {
		this.modifyBodyScroll( open );

		return (
			<div class={`${classes} c-drawer-menu`} style={hide && 'display:none'}>
				<button
					ref={button => this.focusTargets.openButton = button}
					class="c-drawer-menu__open-btn"
					aria-controls="drawer-menu"
					aria-hidden={String( open )}
					tabindex={open ? -1 : 0}
					onClick={this.open}
				>{ localizedStrings.open }</button>

				<button
					class="c-drawer-menu__close-btn"
					aria-controls="drawer-menu"
					aria-hidden={String( ! open )}
					tabindex={open ? 0 : -1}
					onClick={this.close}
				>{ localizedStrings.close }</button>

				<div id="drawer-menu" class="c-drawer-menu__drawer" aria-expanded={String( open )}>
					<h2
						class="c-drawer-menu__title"
						ref={drawerTitle => this.focusTargets.drawerTitle = drawerTitle}
						tabIndex="-1"
					>
						{ localizedStrings.title }
					</h2>
					<Menu menuTree={menuTree} type="drawer" />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/MainMenuDrawer.js